import type { ScheduleElementValues } from './types';

export const MIN_MINUTES_STEP = 15;
export const PARAMETERS_KEYS_SORTED: Array<keyof ScheduleElementValues['parameters']> = [
  'paid',
  'productive',
  'showInOverview',
  'showInOverviewBig',
  'shift',
  'vacation',
  'paidTimeOff',
  'sick',
  'pinnable',
];

export const NOT_DELETABLE_OR_EDITABLE_SCHEDULE_ELEMENTS = ['Sick', 'Vacation'];

export const DEFAULTS_SCHEDULE_ELEMENTS = [
  'Break',
  'Chat',
  'Email',
  'Holiday',
  'Lunch',
  'Meeting',
  'One on One',
  'Sick',
  'Training',
  'Vacation',
  'Voice',
];

export const initialParameters: ScheduleElementValues['parameters'] = {
  paid: false,
  paidTimeOff: false,
  pinnable: false,
  productive: false,
  shift: false,
  showInOverview: false,
  showInOverviewBig: false,
  sick: false,
  vacation: false,
};

export const parametersFieldsNameKeys: Record<keyof ScheduleElementValues['parameters'], string> = {
  paid: 'schedule.element.paid',
  paidTimeOff: 'schedule.element.paidTimeOff',
  pinnable: 'scheduleElements.pinnable',
  productive: 'schedule.element.productive',
  shift: 'shiftTemplate.shift',
  showInOverview: 'scheduleElements.showInOverview',
  showInOverviewBig: 'scheduleElements.showInOverviewBig',
  sick: 'schedule.element.default.Sick',
  vacation: 'schedule.element.default.Vacation',
};

export const DEFAULT_ELEMENTS_ZOOM_LEVEL = 10;

export const initialScheduleElement: ScheduleElementValues = {
  color: '#000', // Black color as a predefined one
  defaultDuration: undefined,
  id: '',
  isWholeDayElement: false,
  name: '',
  parameters: {
    paid: false,
    paidTimeOff: false,
    pinnable: false,
    productive: false,
    shift: false,
    showInOverview: false,
    showInOverviewBig: false,
    sick: false,
    vacation: false,
  },
  tags: [],
  zoomLevel: DEFAULT_ELEMENTS_ZOOM_LEVEL,
};

export const DISABLED_PARAMETERS_KEYS: Array<keyof ScheduleElementValues['parameters']> = [
  'paid',
  'paidTimeOff',
  'productive',
  'shift',
  'sick',
  'vacation',
];

export const PARAMETERS_ERRORS_KEYS_ENDING_PARTS = [
  'productiveAndNotShift',
  'productiveAndPto',
  'productiveAndVacationOrSick',
  'shiftAndPto',
  'shiftAndSick',
  'shiftAndVacation',
  'showInBigOverviewAndShift',
  'vacationAndSick',
];
